import * as React from "react";
import { MobXProviderContext } from "mobx-react";
import { Box, Collapse, Grid } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { useTheme } from "@material-ui/core/styles";
import * as styles from "./styles.scss";
import cx from "classnames";

import { FilesList } from "../Course/Fileslist";
import { tl } from "../../../../utils";

interface IProps {
  isOpen: boolean;
  onToggle(): void;
}

export const Pocket = (props: IProps) => {
  const { fsStore } = React.useContext(MobXProviderContext);
  const theme = useTheme();

  const isOpen = props.isOpen || fsStore.filesCheckedWarning;

  return (
    <Box
      bgcolor={
        isOpen ? theme.palette.grey.A400 : theme.palette.background.paper
      }
      className={styles.pocket}
    >
      <Collapse in={isOpen}>
        <Box
          mt={1}
          bgcolor={theme.palette.background.paper}
          className={styles.pocketList}
        >
          <FilesList simple />
        </Box>
      </Collapse>
      <Box p={1} pl={2}>
        <Grid
          container
          alignItems="center"
          spacing={1}
          className={styles.pocketPanel}
          onClick={props.onToggle}
        >
          <Grid item xs>
            <Grid container spacing={1}>
              <Grid item>{tl("Выбранные файлы")}</Grid>
              <Grid item>
                <Box
                  bgcolor={theme.palette.primary.main}
                  color={theme.palette.common.white}
                  className={styles.pocketBadge}
                >
                  {fsStore.getCheckedFilesCount}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            {isOpen ? (
              <ArrowDropUpIcon style={{ color: theme.palette.primary.light }} />
            ) : (
              <ArrowDropDownIcon
                style={{ color: theme.palette.primary.light }}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
